<template>
  <div
    class="tw:bg-white tw:border tw:border-gray-300 tw:rounded-xl tw:flex tw:p-4 tw:gap-4 tw:flex-col tw:md:flex-row tw:max-w-full"
  >
    <img :src="imageIcon" alt="Image" class="tw:self-start" />
    <div class="tw:flex tw:flex-col tw:gap-4 tw:w-full">
      <div>
        <h1 class="tw:mb-1 tw:text-xl tw:font-bold">
          {{ $t('plus_tips_images_header') }}
        </h1>
        <p v-html="$t('plus_tips_images_subtext')" />
      </div>
    </div>
    <div class="tw:md:self-center">
      <router-link
        @click="logEvents"
        :to="{ name: 'property-details-images' }"
        class="tw:font-bold tw:text-blue-700 tw:text-nowrap"
        >{{ $t('plus_tips_cta') }}</router-link
      >
    </div>
  </div>
</template>
<script setup>
import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const imageIcon = new URL('/src/assets/img/studio-plus-insights/image-icon.svg', import.meta.url)

const logEvents = () => {
  appAnalytics.track(appAnalytics.events.SP_PLUS_INSIGHTS_TIP_IMAGES_CLICKED, {
    item_id: selectedAccommodationId.value,
  })
}
</script>
